import { render, staticRenderFns } from "./CategeoryQuestionnaire.vue?vue&type=template&id=24d5a537&scoped=true"
import script from "./CategeoryQuestionnaire.vue?vue&type=script&lang=js"
export * from "./CategeoryQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./CategeoryQuestionnaire.vue?vue&type=style&index=0&id=24d5a537&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5a537",
  null
  
)

export default component.exports